/* eslint-disable */
/* eslint-disable no-unused-vars */
import api from "api";
import { useAuth } from "context/auth";
import { handleLoading, useLoading } from "context/LoadingContext";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import addNewLog from "utils/addNewLog";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";
import { generateTextFromJson } from "utils/generateTextFromJson";

/* eslint-disable react/jsx-curly-brace-presence */
function Comment(props) {
  const [, loadingDispatch] = useLoading();
  const [auth] = useAuth();

  const { comment, getPaymentsLogs, toggleComment } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    const { status, comment: actualComment, ePaymentNumber } = comment || {};
    reset({
      status: JSON.stringify(status === null ? true : status),
      comment: actualComment,
      ePaymentNumber,
    });
  }, [comment]);
  const onSubmit = async (data) => {
    await addNewLog({
      ipAddress: auth.ipAddress,
      hostname: auth.hostname,
      logDescription: `${generateTextFromJson({feildStatus:data?.status},"تعديل الحاله الى  ")} `});
    const dataToSubmit = { ...data, status: JSON.parse(data.status) };
    handleLoading(loadingDispatch, true);
    try {
      await api.post("payment/update", dataToSubmit);
      await getPaymentsLogs();
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
    toggleComment();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="mb-3 input input-md" controlId="comment">
        <Form.Label>ملاحظات</Form.Label>
        <Form.Control
          autoComplete="false"
          type="text"
          {...register("comment", { required: "الرجاء ادخال الحقل" })}
        />
        {errors.comment && (
          <Form.Text className="text-danger">
            {errors.comment.message}
          </Form.Text>
        )}
      </Form.Group>
      <Form.Group className="mb-3 input input-md" controlId="status">
        <Form.Label>الحالة</Form.Label>
        <div style={{ width: "fit-content", display: "flex", gap: "1rem" }}>
          <Form.Check // prettier-ignore
            type={"radio"}
            id={`status-true`}
            label={`مدفوع`}
            value="true"
            name="status"
            {...register("status")}
          />
          <Form.Check // prettier-ignore
            type={"radio"}
            id={`status-false`}
            label={`ملغي`}
            value="false"
            name="status"
            {...register("status")}
          />
        </div>
        {errors.الحالة && (
          <Form.Text className="text-danger">{errors.الحالة.message}</Form.Text>
        )}
      </Form.Group>
      <div style={{ display: "flex", gap: "1rem" }}>
        <button className="btn btn--primary" type="submit">
          تعديل
        </button>
      </div>
    </form>
  );
}

Comment.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  comment: PropTypes.object.isRequired,
  getPaymentsLogs: PropTypes.func.isRequired,
  toggleComment: PropTypes.func.isRequired,
};

export default Comment;
